<template lang="pug">
    div
        .text-center(v-if="isLoading")
            v-progress-circular(
                :size='100'
                :width='10'
                color='var(--volie-blue)'
                indeterminate
                style="margin-top: 75px; margin-bottom: 75px;"
            )
        VolieTranscription(
            v-if="callTranscription"
            :callTranscription="callTranscription"
            :conference="conference"
            :isLoading="isLoading"
        )
        v-alert(
            v-else-if="complianceTranscriptUnavailable"
            outlined
            type="warning"
            dense
            border="left"
            style="margin: 10px 40px 10px 20px;"
        )
            | Transcript removed for two-party recording consent compliance.
        v-alert(v-else outlined type='info' dense border='left' style="margin: 10px 40px 10px 20px;")
            | Unable to find call transcription.


</template>

<script lang="ts">
import Vue from 'vue';

// Components
import VolieTranscription from '@/components/conferences/call_transcriptions/volie_transcription.vue';

export default Vue.extend({
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {

    },
    components: {
        VolieTranscription,
    },
    props: {
        callTranscription: Object,
        conference: Object,
        isLoading: Boolean,
        complianceTranscriptUnavailable: {
            type: Boolean,
            default: false,
        },
    },
    watch: {

    },
    created() {
    },
    destroyed() {
    },
    mounted() {
    },
})
</script>

<style lang="scss" scoped>

</style>
